import getSettings from '@/api/get-settings';

const exinoneReferenceId = 1;

export const settingsState = {
  settings: {
    exinoneReferenceId: exinoneReferenceId,
    isSettingsLoaded: false,
    cryptoList: [],
    paymentList: [],
    locationList: [],
    legalCurrencyList: [],
    property: [],
    referenceList: [
      {
        id: 0,
        text: 'CoinMarketCap(AVG)',
        value: 'avg',
      },
      {
        id: exinoneReferenceId, // exinone
        text: '',
        value: 'exinone',
      },
    ],
    timeZoneList: new Array(27).fill('').map((v, i) => {
      let value = i - 12;
      let str = 'GMT';
      if (value > 0) {
        str += '+';
      } else if (value < 0) {
        str += '-';
        value = -value;
      }
      if (value < 10) {
        str += '0' + value;
      } else {
        str += value;
      }
      str += ':00';
      return {
        value: i - 12,
        text: str,
      };
    }),
    timeList: new Array(25).fill('').map((v, i) => {
      return {
        value: i,
        text: `${i}:00`,
      };
    }),
    rate: {
      responseRate: '-',
      advertisementRate: '-',
    },
    hostData: {
      primaryHostUrl: '',
      currentHostUrl: '',
      webNum: 0,
      isPrimaryWeb: '',
      clientId: '',
    },
  },
};

export const settingsMutations = {
  setSettings(state, obj) {
    Object.assign(state.settings, obj);
  },
};

export const settingsActions = {
  updateSettings({ commit }) {
    return getSettings()
      .then(data => {
        const cryptoList = data.assets.map(asset => {
          return {
            id: asset.id,
            name: asset.name,
            symbol: asset.symbol,
            iconUrl: asset.iconUrl,
            uuid: asset.mixinId,
            exinSupported: !!+asset.isExin,
            exinDecimalDigit: asset.exinDecimalDigit,
          };
        });
        const paymentList = data.pay_methods.map(payment => {
          return {
            id: payment.id,
            name: payment.name,
            iconUrl: payment.iconUrl,
            value: payment.symbol || '',
            type: payment.type,
            isUse: payment.is_use,
          };
        });
        const locationList = data.locations.map(location => {
          return {
            id: location.id,
            name: location.name, // 国家代号，多语言切换用
          };
        });
        const legalCurrencyList = data.legal_currencies.map(currency => {
          return {
            id: currency.id,
            name: currency.name,
            unit: currency.symbol,
            decimal: currency.decimal_digit,
            type: currency.type,
            isUse: currency.is_use,
          };
        });
        const property = data.property.map(item => {
          return {
            id: item.id,
            en: item.enName,
            'zh-cn': item.name,
            enRemark: item.enRemark || '',
            'zh-cnRemark': item.remark || '',
            default: !!+item.isDefault,
            isLandun: !!+item.isLandun,
            isOversea: !!+item.isOversea,
          };
        });
        const rate = {
          responseRate: data.rate.response_rate,
          advertisementRate: data.rate.advertisement_rate,
        };
        const hostData = {
          primaryHostUrl: data.hostData.primaryHostUrl,
          currentHostUrl: data.hostData.currentHostUrl,
          webNum: data.hostData.webNum,
          isPrimaryWeb: data.hostData.isPrimaryWeb,
          clientId: data.hostData.clientId,
        };
        commit('setSettings', {
          isSettingsLoaded: true,
          cryptoList,
          paymentList,
          locationList,
          legalCurrencyList,
          rate,
          property,
          hostData,
        });
        return Promise.resolve(data);
      })
      .catch(err => Promise.reject(err));
  },
};
